export default {"src":"/_next/static/media/gemini.cb778bb8.svg","height":16,"width":16};